import type { Language } from 'element-plus/es/locale'

export interface AdminLocaleDefinition {
  code: string
  name: string
  order: number
  elementPlusLocale: Language
  messages: Record<string, unknown>
}

export const defineAdminLocale = <T extends AdminLocaleDefinition>(locale: T): T => locale
